/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import 'contents/assets/scss/page/promotion.scss';

const InboundTeamDtail = () => {
  const navigate = useNavigate();
  const {tabNumber} = useParams();
  const [tabIdx, setTabIdx] = useState(Number(tabNumber) || 0);

  const tab = [
    {title: '상담대기', value: 0},
    {title: '인바운드', value: 1, type: 'bar'},
    {title: '진행중인 상담', value: 2},
    {title: '종료 상담', value: 3},
    {title: '성공 상담', value: 4, type: 'bar'},
    {title: '전화번호 정보 검색', value: 5, type: 'bar'},
    {title: '내 통계', value: 6}
  ];
  return (
    <main className="com_container p_inboun_team_detail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu7_4">인바운드팀</h2>
        </section>
        <section className="com_pg_container com_input_sec">
          <div className="com_board_list__top">
            <section className="com_tab">
              {tab.map((item, idx) => {
                return (
                  <button
                    key={idx}
                    className={`tab ${tabIdx === item.value ? 'active' : ''} ${item.type ? item.type : ''}`}
                    onClick={() => {
                      navigate('/Promotion/InboundTeam');
                    }}
                  >
                    {item.title ? item.title : ``}
                  </button>
                );
              })}
            </section>
          </div>
          {tabIdx === 2 && (
            <>
              <section className="box full box_first">
                <hr className="com_divider" />
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="148" />
                    <col width="508" />
                    <col width="148" />
                    <col width="508" />
                    <col width="148" />
                    <col width="508" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>전화번호</th>
                      <td>010-1111-1111</td>
                      <th>이름</th>
                      <td>홍길동</td>
                      <th>구분</th>
                      <td>학부모</td>
                    </tr>
                    <tr>
                      <th>학년</th>
                      <td>N수생</td>
                      <th>구분</th>
                      <td>이지수능교육</td>
                      <th>신청페이지</th>
                      <td>정시정밀컨설팅</td>
                    </tr>
                    <tr>
                      <th>희망시간</th>
                      <td>상시가능</td>
                      <th>등록일</th>
                      <td colSpan={3}>약 3개월 전 (2023년 12월 15일(금) 오후 5시 2분</td>
                    </tr>
                    <tr>
                      <th>상태</th>
                      <td colSpan={5}>
                        <div className="com_input_wrap">
                          <select name="" id="" className="select ws">
                            <option value="">대기</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>메모</th>
                      <td colSpan={5}>
                        <textarea name="" id="" className="textarea"></textarea>
                        <div className="input_info">2023년 12월 15일(금) 오후 5시 18분, 홍길동101</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="com_btn_wrap bottom">
                  <button onClick={() => navigate('/Promotion/InboundTeam')} className="com_btn gray s">
                    목록 돌아가기
                  </button>
                  <button className="com_btn orange s">메모 저장</button>
                  <button className="com_btn gray s">홍보 문자 전송</button>
                </div>
              </section>
              <div className="box_wrap">
                <section className="box">
                  <div className="com_info">
                    <p className="name">이지수능교육</p>
                    <p className="date dot">현재 상담</p>
                    <p className="date dot">약 3개월 전 (2023년 12월 15일(금) 오후 5시 2분</p>
                  </div>
                  <div className="com_board_box">
                    <div className="board_item">
                      <div className="info">
                        <span className="tit">상태</span>
                        <span className="cont">대기</span>
                      </div>
                      <div className="info">
                        <span className="tit">학생</span>
                        <span className="cont">홍길동</span>
                      </div>
                      <div className="info">
                        <span className="tit">학년</span>
                        <span className="cont bold">N수</span>
                      </div>
                    </div>
                  </div>
                  <div className="textarea_wrap">
                    <textarea name="" id="" className="textarea"></textarea>
                    <div className="input_info">2023년 12월 15일(금) 오후 5시 18분, 홍길동101</div>
                  </div>
                </section>
                <section className="box">
                  <table className="com_board_list type_row">
                    <colgroup>
                      <col width="130" />
                      <col width="210" />
                      <col width="130" />
                      <col width="220" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>소속지점</th>
                        <td colSpan={3}>
                          <div className="check">
                            <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                            <label htmlFor="rdo_01">본사</label>
                            <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                            <label htmlFor="rdo_02">부산</label>
                            <input type="radio" name="rdo" id="rdo_03" className="com_chk circle" />
                            <label htmlFor="rdo_03">화상교육</label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>번호구분</th>
                        <td colSpan={3}>
                          <div className="check">
                            <input type="radio" name="rdo1" id="rdo_11" className="com_chk circle" />
                            <label htmlFor="rdo_11">어머님</label>
                            <input type="radio" name="rdo1" id="rdo_12" className="com_chk circle" />
                            <label htmlFor="rdo_12">학생</label>
                            <input type="radio" name="rdo1" id="rdo_13" className="com_chk circle" />
                            <label htmlFor="rdo_13">아버님</label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>시강종류</th>
                        <td colSpan={3}>
                          <div className="check">
                            <input type="radio" name="rdo2" id="rdo_21" className="com_chk circle" />
                            <label htmlFor="rdo_21">방문시강</label>
                            <input type="radio" name="rdo2" id="rdo_22" className="com_chk circle" />
                            <label htmlFor="rdo_22">화상시강</label>
                            <input type="radio" name="rdo2" id="rdo_23" className="com_chk circle" />
                            <label htmlFor="rdo_23">유료시강</label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>시강과목</th>
                        <td colSpan={3}>
                          <div className="check">
                            <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                            <label htmlFor="chk01">국어</label>
                            <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                            <label htmlFor="chk02">수학</label>
                            <input type="checkbox" name="chk" id="chk03" className="com_chk" />
                            <label htmlFor="chk03">영어</label>
                            <input type="checkbox" name="chk" id="chk04" className="com_chk" />
                            <label htmlFor="chk04">사탐</label>
                            <input type="checkbox" name="chk" id="chk05" className="com_chk" />
                            <label htmlFor="chk05">과탐</label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>시강일자</th>
                        <td className="td_left">
                          <div className="com_input_wrap">
                            <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                          </div>
                        </td>
                        <th>시강시간</th>
                        <td>
                          <div className="com_input_wrap flex_row">
                            <select name="" id="" className="select wxs">
                              <option value="">오후 9시</option>
                            </select>
                            <select name="" id="" className="select wxs">
                              <option value="">00분</option>
                            </select>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>학생이름</th>
                        <td>
                          <input type="text" className="input" />
                        </td>
                        <th>학년</th>
                        <td>
                          <div className="com_input_wrap">
                            <select name="" id="" className="select">
                              <option value="">선택</option>
                            </select>
                            <p className='com_tip right s gray'>* 24년기준</p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>주소</th>
                        <td colSpan={3} className='address_field'>
                          <div className="com_input_wrap flex_row">
                            <input type="text" className="input" placeholder="우편번호" />
                            <button className="com_btn gray s wl">우편번호</button>
                          </div>
                          <div className="com_input_wrap">
                            <input type="text" className="input full" placeholder="도로명" />
                          </div>
                          <div className="com_input_wrap">
                            <input type="text" className="input full" placeholder="지번" />
                          </div>
                          <div className="com_input_wrap">
                            <input type="text" className="input full" placeholder="상세주소" />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>컨택날짜 </th>
                        <td className="td_left">
                          <div className="com_input_wrap">
                            <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                          </div>
                        </td>
                        <th>학생성별</th>
                        <td>
                          <div className="check">
                            <input type="radio" name="rdo3" id="rdo_31" className="com_chk circle" />
                            <label htmlFor="rdo_31">남자</label>
                            <input type="radio" name="rdo3" id="rdo_32" className="com_chk circle" />
                            <label htmlFor="rdo_32">여자</label>
                            <input type="radio" name="rdo3" id="rdo_33" className="com_chk circle" />
                            <label htmlFor="rdo_33">모름</label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>학교명</th>
                        <td>
                          <input type="text" className="input" />
                        </td>
                        <th>계열</th>
                        <td>
                          <div className="com_input_wrap">
                            <select name="" id="" className="select">
                              <option value="">선택</option>
                            </select>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>메모</th>
                        <td colSpan={3}>
                          <textarea name="" id="" className="textarea" placeholder="내용 입력"></textarea>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="com_btn_wrap bottom center">
                    <button className="com_btn orange s">시강 신청</button>
                  </div>
                </section>
              </div>
            </>
          )}
          {tabIdx === 3 && (
            <>
              <section className="box full box_first">
                <hr className="com_divider" />
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="148" />
                    <col width="508" />
                    <col width="148" />
                    <col width="508" />
                    <col width="148" />
                    <col width="508" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>전화번호</th>
                      <td>010-1111-1111</td>
                      <th>이름</th>
                      <td>홍길동</td>
                      <th>구분</th>
                      <td>학부모</td>
                    </tr>
                    <tr>
                      <th>학년</th>
                      <td>N수생</td>
                      <th>구분</th>
                      <td>이지수능교육</td>
                      <th>신청페이지</th>
                      <td>정시정밀컨설팅</td>
                    </tr>
                    <tr>
                      <th>희망시간</th>
                      <td>상시가능</td>
                      <th>등록일</th>
                      <td colSpan={3}>약 3개월 전 (2023년 12월 15일(금) 오후 5시 2분</td>
                    </tr>
                    <tr>
                      <th>상태</th>
                      <td colSpan={5}>
                        <div className="com_input_wrap">
                          <select name="" id="" className="select ws">
                            <option value="">대기</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>메모</th>
                      <td colSpan={5}>
                        <textarea name="" id="" className="textarea" placeholder="내용 입력"></textarea>
                        <p className='input_info'>2023년 12월 15일(금) 오후 5시 18분, 홍길동101</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="com_btn_wrap bottom">
                  <button onClick={() => navigate('/Promotion/InboundTeam')} className="com_btn gray s">
                    목록 돌아가기
                  </button>
                  <button className="com_btn orange s">메모 저장</button>
                  <button className="com_btn gray s">홍보 문자 전송</button>
                </div>
              </section>
              <section className="box full">
                <div className="com_info">
                  <p className="name">이지수능교육</p>
                  <p className="date dot">현재 상담</p>
                  <p className="date dot">약 3개월 전 (2023년 12월 15일(금) 오후 5시 2분</p>
                </div>
                <div className="items_row">
                  <div className="item com_board_box">
                    <div className="board_item">
                      <div className="info">
                        <span className="tit">상태</span>
                        <span className="cont">대기</span>
                      </div>
                      <div className="info">
                        <span className="tit">학생</span>
                        <span className="cont">홍길동</span>
                      </div>
                      <div className="info">
                        <span className="tit">학년</span>
                        <span className="cont bold">N수</span>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <textarea name="" id="" className="textarea"></textarea>
                    <div className="input_info">2023년 12월 15일(금) 오후 5시 18분, 홍길동101</div>
                  </div>
                </div>
              </section>
            </>
          )}
          {tabIdx === 4 && (
            <>
              <section className="box full box_first">
                <hr className="com_divider" />
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="148" />
                    <col width="652" />
                    <col width="148" />
                    <col width="652" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>수신번호</th>
                      <td>010-1111-1111</td>
                      <th>수신일자</th>
                      <td>5시간 48분 전 (2024년 3월 12일(화) 오후 2시 55분)</td>
                    </tr>
                    <tr>
                      <th>비회원문의 등록인</th>
                      <td>홍길동101</td>
                      <th>비회원문의 등록일</th>
                      <td>5시간 48분 전 (2024년 3월 12일(화) 오후 2시 55분)</td>
                    </tr>
                    <tr>
                      <th>비회원문의</th>
                      <td colSpan={3}>수시컨설팅 문의 (모폰) / 최대한 빨리 연락 요망 / 고1(쌍둥이_한지영(여), 한재영(남)</td>
                    </tr>
                    <tr>
                      <th>상태</th>
                      <td colSpan={3}>시강대기</td>
                    </tr>
                    <tr>
                      <th>메모</th>
                      <td colSpan={3}>
                        <textarea name="" id="" className="textarea" placeholder="내용 입력"></textarea>
                        <p className='input_info'>2023년 12월 15일(금) 오후 5시 18분, 홍길동101</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="com_btn_wrap bottom">
                  <button onClick={() => navigate('/Promotion/InboundTeam')} className="com_btn gray s">
                    목록 돌아가기
                  </button>
                </div>
              </section>
              <section className="box full box_second">
                <div className="com_info">
                  <p className="name">비회원문의</p>
                  <p className="date dot">현재 상담</p>
                  <p className="date dot">약 3개월 전 (2023년 12월 15일(금) 오후 5시 2분</p>
                </div>
                <div className="items_row">
                  <div className="item com_board_box">
                    <div className="com_bk_txt">문의등록</div>
                    <textarea name="" id="" className="textarea" defaultValue={`내용`}></textarea>
                    <div className="input_info">2023년 12월 15일(금) 오후 5시 18분, 홍길동101</div>
                  </div>
                  <div className="item">
                    <div className="com_bk_txt">처리답변</div>
                    <textarea name="" id="" className="textarea" defaultValue={`내용`}></textarea>
                    <div className="input_info">2023년 12월 15일(금) 오후 5시 18분, 홍길동101</div>
                  </div>
                </div>
              </section>
              <section className="box full">
                <div className="com_info">
                  <p className="name">이지수능교육</p>
                  <p className="date dot">약 3개월 전 (2023년 12월 15일(금) 오후 5시 2분</p>
                </div>
                <div className="items_row">
                  <div className="item com_board_box">
                    <div className="board_item">
                      <div className="info">
                        <span className="tit">상태</span>
                        <span className="cont">대기</span>
                      </div>
                      <div className="info">
                        <span className="tit">학생</span>
                        <span className="cont">홍길동</span>
                      </div>
                      <div className="info">
                        <span className="tit">학년</span>
                        <span className="cont bold">N수</span>
                      </div>
                    </div>
                  </div>
                  <div className="item">
                    <textarea name="" id="" className="textarea" defaultValue={`문자 남김`}></textarea>
                    <div className="input_info">2023년 12월 15일(금) 오후 5시 18분, 홍길동101</div>
                  </div>
                </div>
              </section>
            </>
          )}
        </section>
      </div>
    </main>
  );
};

export default InboundTeamDtail;
